import { render, staticRenderFns } from "./EventRatings.vue?vue&type=template&id=f0925bf8&scoped=true"
import script from "./EventRatings.vue?vue&type=script&lang=js"
export * from "./EventRatings.vue?vue&type=script&lang=js"
import style0 from "./EventRatings.vue?vue&type=style&index=0&id=f0925bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0925bf8",
  null
  
)

export default component.exports